import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5e3d7626"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]

import { type CSSProperties } from 'vue'

interface TabItem {
  key: string
  label: string
  color?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Tabs',
  props: {
    value: {},
    tabs: {},
    card: { type: Boolean, default: false },
    tabsStyle: {},
    tabStyle: {},
    spaceAround: { type: Boolean, default: false },
    spaceBetween: { type: Boolean, default: false }
  },
  emits: ["update:value"],
  setup(__props: any, { emit: __emit }) {



const emit = __emit

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tabs", {
      'card': _ctx.card,
      'space-around': _ctx.spaceAround,
      'space-between': _ctx.spaceBetween,
    }]),
    style: _normalizeStyle(_ctx.tabsStyle || {})
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab) => {
      return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["tab", { 'active': tab.key === _ctx.value }]),
        key: tab.key,
        style: _normalizeStyle({
        ...(_ctx.tabStyle || {}),
        '--color': tab.color,
      }),
        onClick: ($event: any) => (emit('update:value', tab.key))
      }, _toDisplayString(tab.label), 15, _hoisted_1))
    }), 128))
  ], 6))
}
}

})